import IconButton from '@/global/components/Button/IconButton'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import Typography from '@mui/material/Typography'
import Dialog from 'global/guides/Dialog'
import { Settings2Icon } from 'lucide-react'
import React, { Fragment } from 'react'

const OpcoesLog: React.FC<GridCellParams> = ({ row }) => {
    const disabled = !!row?.message && !!row?.exception

    const [open, setOpen] = React.useState(false)

    if (!disabled) {
        return (
            <IconButton disabled>
                <Settings2Icon />
            </IconButton>
        )
    }

    const regex = /\/home.*?\/pontoagil/g

    return (
        <>
            <IconButton onClick={() => setOpen(true)}>
                <Settings2Icon />
            </IconButton>
            <Dialog.Root
                open={open}
                onClose={() => setOpen(false)}
                width="46rem"
                height="fit-content"
            >
                <Dialog.Content>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                        {row?.message}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            mt: 1,
                            mb: -2,
                            fontWeight: 'bold',
                            padding: 2,
                            background: '#2c2c2c',
                            color: 'white',
                            borderRadius: 1,
                        }}
                    >
                        {row?.exception
                            .trim()
                            .split('\n')
                            .map((line: string, index: number) => (
                                <Fragment key={index}>
                                    {line.replace(regex, '**')}
                                    <br />
                                </Fragment>
                            ))}
                    </Typography>
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                </Dialog.Actions>
            </Dialog.Root>
        </>
    )
}

export default OpcoesLog
